module.exports = __webpack_public_path__ + "img/ZeldaSaveFile.9f76b8bf.png";